<script setup lang="ts">
const skeletonColumns = ref(4)
const skeletonItems = ref(25)
</script>

<template>
  <div class="grid-standard py-4 md:py-6">
    <SkeletonAnimatedPlaceholder
      width="250px"
      height="30px"
      borderRadius="5px"
      class="col-span-full mb-6 md:col-span-10 md:col-start-2"
    />

    <div class="grid-container col-span-full md:col-span-10 md:col-start-2">
      <div
        v-for="(column, index) in skeletonColumns"
        :key="`column-${index}`"
        class="col-span-full flex flex-col gap-4 md:col-span-3"
      >
        <SkeletonAnimatedPlaceholder
          v-for="(item, index) in skeletonItems"
          :key="`skeleton-item-${index}`"
          height="15px"
          width="100%"
          borderRadius="5px"
        />
      </div>
    </div>
  </div>
</template>
